import { TextLink } from '@vds/buttons'
import { Icon } from '@vds/icons'
import { ListItem, UnorderedList } from '@vds/lists'
import { TileContainer } from '@vds/tiles'
import { Body, Title } from '@vds/typography'
import React, { useEffect, useState } from 'react'
import './EventPreview.scss'
import { useSelector } from 'react-redux'
import { decodeHTML } from '../../../utility/common'
import DOMPurify from 'dompurify';
import { isMobile } from 'react-device-detect'
import EventImage from '../../../assets/images/Image.png'

const EventPreview = ({isInPersonEvent,currentEvent, eventCxAemData, eventPreviewCardData }) => {
  const inPersonEventCxAemData = useSelector((state) => state.Aem.inPersonEventCxData);
  const aemData = isInPersonEvent ? inPersonEventCxAemData: eventCxAemData;
 const [imageUrl, setImageUrl] = useState('');
  function transformString(inputString) {
    const stringWithoutSpaces = inputString.replace(/\s/g, '');
    const lowercaseString = stringWithoutSpaces.toLowerCase();
    return lowercaseString;
  }

  let type = '';
  if(currentEvent?.tags?.indexOf('Group Session') != -1) {
    type = 'Group Session';
  } else if (currentEvent?.tags?.indexOf('Workshop/Networking') != -1) {
    type = 'Workshop Networking';
  } else if (currentEvent?.tags?.indexOf('Office Hours') != -1) {
    type = 'Office Hours';
  } else if (currentEvent?.tags?.indexOf('Community') != -1) {
    type = 'Community';
  }

  let allTopics=[];
  let allTopicsKey=[];
  eventCxAemData?.allTopics?.allTopicsData?.map(item =>{
    allTopics[item?.value?.toLowerCase().split(' ').join('')] =item;
    allTopicsKey.push(item?.value?.toLowerCase()?.split(' ')?.join(''))
  });
  let courseTopics = [];
  currentEvent?.tags?.map(item => {
    if (allTopicsKey?.includes(item?.toLowerCase()?.split(' ')?.join(''))) {
      courseTopics.push(item?.toLowerCase()?.split(' ')?.join(''))
    }
  });
  const lng = localStorage.getItem("lng") ?? 'en';
  let previewCards=[];
  const aemUrlurlpath = `${global.config.AEM_API_BASE_PATH}`;
  // const previewData = lng==='es' ? currentEvent?.localizeData?.[1] : currentEvent?.localizeData?.[0];
  // const previewData = lng === 'es' ? currentEvent?.localizeData?.filter((item) => item?.locale === "es-ES") : currentEvent?.localizeData?.map((item) => item?.locale === "en-US");
  const previewData = currentEvent?.localizeData?.filter((item) =>{
     if(lng==='es' && item?.locale === "es-ES"){
      return item;
     }else if(lng === 'en' && item?.locale === "en-US"){
      return item;
     }
  })

  function convertQuotedHtmlToPlain(quotedHtml) {
    // Remove the quotes, unescape characters, and clear href value
    const userHtml = quotedHtml?.replace(/^"/, '') // Remove starting quote
      ?.replace(/^"/, '') // Remove starting quote
      ?.replace(/"$/, '') // Remove ending quote
      ?.replace(/\\"/g, '"') // Unescape double quotes
      ?.replace(/\n/g, '') // Remove actual newline character
      ?.replace(/^<p>(.*?)<\/p>$/, '$1'); // Remove outer <p> tags
    const sanitizedHtml = DOMPurify.sanitize(userHtml);
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
      />
    );
  }

  aemData?.overview?.filter((item)=>{
    // currentEvent?.format
    if( (item?.icon=="services" && transformString(type)!=transformString(item?.key)) || ( item?.key=="Languagesupported" && lng=='en' && currentEvent?.locale?.includes('en-US') && !currentEvent?.locale?.includes('es-ES') )){
            return;
    }
    if(item?.key==='ideal'){
    
        if(previewData?.[0]?.previewData?.[0]?.sectionOne?.length>0){
          previewCards?.push(item);
        }
     
    }else if(item?.key==='tools'){
      
        if(previewData?.[0]?.previewData?.[0]?.sectionTwo?.length>0){
          previewCards?.push(item);
        }
           
    }else if(item?.key==='prior'){
     
        if(previewData?.[0]?.previewData?.[0]?.sectionThree?.length>0){
          previewCards?.push(item);
        }
    
    }else if(item?.icon==='handshake' && item?.key?.toLowerCase() != previewData?.[0]?.hostDetails?.type?.toLowerCase()){
      return
    }else if(item?.key==='topics'){
     if(courseTopics?.length>0){
        previewCards?.push(item);
      }
    }else if(item?.key.toLowerCase() ==='free' || (item?.icon==='coin' && previewData?.[0]?.pricingInfo?.cost == null) ){
      return
    }else if(item?.key==='info' &&  previewData?.[0]?.additionalInfo == null){
      return
    }else{
      previewCards?.push(item);
    }
    
  });

  const cardCount = previewCards?.length;

  const hasTwoCardsWithHandshakeAndPlatform =
    cardCount === 2 &&
    previewCards.some((card) => card.icon === 'handshake') &&
    previewCards.some((card) => card.icon === 'platform');

  const gridClass =
    cardCount % 2 === 0
      ? 'coursePreviewContainer four-cards'
      : cardCount % 2 === 1 && cardCount > 1
        ? 'coursePreviewContainer three-cards'
        : 'coursePreviewContainer';
  const visibleCards = eventPreviewCardData;

// image management logic

useEffect(() => {
  // Helper to test if a URL is valid and reachable within 2 seconds
  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (!url || url.trim() === "") return reject(new Error("Invalid URL"));
      const img = new Image();
      img.src = url;
      const timeout = setTimeout(() => {
        img.src = ""; // Stop the browser from continuing to load
        reject(new Error("Timeout"));
      }, 2000);
      
      img.onload = () => {
        clearTimeout(timeout);
        resolve(url);
      };
      img.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Image Load failed"));
      };
    });
  };

   const loadImage = async () => {
    
    setImageUrl('');

    try {
      // 1.Call method with "avif" parameter
      try {
       const avifUrl = await getImageToBeRendered('', '', '', '', previewData?.[0]?.hostDetails?.hostLogo, '', 'hostLogo',);
        await preloadImage(avifUrl);
        setImageUrl(avifUrl);
        return; 
      } catch (e) {
        console.warn("AVIF failed, trying PNG...");
      }

          const dataFallbackUrl = currentEvent?.desktopImage;
      if (dataFallbackUrl) {
        try {
          await preloadImage(dataFallbackUrl);
          setImageUrl(dataFallbackUrl);
          return;
        } catch (e) {
          console.warn("fallback image failed to load.");
        }
      }

      // setting ulr as empty string
      setImageUrl('');    

    } catch (error) {
     
      setImageUrl('');
    } finally {
      
    }
  };

  loadImage();
}, [currentEvent]);

//



  return (
    <div className={gridClass}>
         {/* ADD THIS: Conditional inPerson full-span card */}
      {previewCards?.map((card, idx) => 
        isInPersonEvent && card.icon === 'handshake' ?
        <div className="course_card_tile course_card_tile--fullspan course_card_tile--inperson">
          <TileContainer
            className="tileContainer"
            padding={isMobile ? "16px" : "24px"}
            aspectRatio="none"
            width="100%"
            height="100%"
            showDropShadow="true"
           backgroundColor="#fff"
          >
            <div className='flex-apart width-100 sm-n-flexDirectionCol'>
            <div className='n-displayFlex'>
              <Icon name={card.icon} size={isMobile ? 'large' : 'XLarge'} />
              <div className='ml-3X'>
                <Title size='smallBold'>{card?.title}{previewData?.[0]?.hostDetails?.name ?? null}</Title>
                <div className='mt-2X'>
                  <Body size="medium">
                     {decodeHTML(previewData?.[0]?.hostDetails?.description ?? '')}
                  </Body>          
                </div>
              </div>
            </div>
            {previewData?.[0]?.hostDetails?.hostLogo != null && <div className='checker_image sm-mt-4X'>
              <img src={imageUrl ? imageUrl  : previewData?.[0]?.hostDetails?.hostLogo} alt="Event" />
              </div>}
            </div>
          </TileContainer>
        </div>:
        <div
          className={
            hasTwoCardsWithHandshakeAndPlatform && card.icon === 'platform'
              ? 'course_card_tile course_card_tile--fullspan'
              : 'course_card_tile'
          }
          key={card?.key || card?.id || idx}
        >
          <TileContainer
            className="tileContainer"
            padding={isMobile ? "16px" : "24px"}
            aspectRatio="none"
            width="100%"
            height="100%"
            showDropShadow="true"
            backgroundColor="#fff"
          >
            <div className='n-displayFlex'>
              <Icon name={card.icon} size={isMobile ? 'large' : 'XLarge'} />
              <div className='ml-3X'>
                <Title size='small'>{card?.key === 'info'? previewData?.[0]?.additionalInfo?.title : card?.title}</Title>
                <div className='mt-2X'>
                  {card?.key === 'info'? previewData?.[0]?.additionalInfo?.description && <Body>{decodeHTML(previewData?.[0]?.additionalInfo?.description)}</Body> : card?.icon === 'coin'? <Body>{decodeHTML(previewData?.[0]?.pricingInfo?.description)}</Body>:
                    card?.key === 'Languagesupported' ? (
                      <Body>
                    {/* <UnorderedList>
                      <ListItem size="bodyMedium" surface="light" spacing="compact"> */}
                        {/* <TextLink type="standAlone" size="small" onClick={e => alert('TextLink clicked')}>
                          Disponible en español
                        </TextLink> */}
                        {(lng=='en' && (currentEvent?.locale?.includes('en-US') && currentEvent?.locale?.includes('es-ES'))) ? decodeHTML(card?.bilingualEventEnTxt) : (lng=='en' && currentEvent?.locale?.includes('es-ES') ? decodeHTML(card?.spanishEnText) : (lng=='es' && (currentEvent?.locale?.includes('es-ES') && currentEvent?.locale?.includes('en-US')) ? decodeHTML(card?.bilingualEventEsTxt) : (lng=='es' && currentEvent?.locale?.includes('en-US')) ? decodeHTML(card?.englishEsText) : (lng=='es' && currentEvent?.locale?.includes('es-ES')) ? decodeHTML(card?.spanishEsText) : '') )}
                      {/* </ListItem> */}
                      {/* <ListItem size="bodySmall" surface="light" spacing="compact">
                        Chinese subtitles and downloadable materials available (
                        <TextLink type="standAlone" size="small" onClick={e => alert('TextLink clicked')}>
                          set subtitles to Chinese
                        </TextLink>)
                      </ListItem> */}
                     {/* </UnorderedList> */}
                    </Body>
                  ) : card?.key === 'topics' ? (
                    // <TextLink type="standAlone" size="medium" tabIndex={-1} >
                    <div className='topic_container'>
                    <div className="mt-4X course_preview_tag_container">
                      {currentEvent?.tags?.map((tag, index) => {
                        if(allTopics.hasOwnProperty(tag?.toLowerCase().split(' ').join(''))){ 
                          const isNonClickable= allTopics?.[tag.toLowerCase().split(' ').join('')]?.noResultsPage =='true' ? true : false;
                          const divStyle = { cursor: isNonClickable ? 'default' : 'pointer'  };

                           return <TextLink style={divStyle} type="standAlone" size="medium" className="course_preview_tag" onClick={()=>{
                            if(allTopics?.[tag.toLowerCase().split(' ').join('')]?.noResultsPage !='true'){
                              document.location.href= (lng=='en' ? `/results/${tag.toLowerCase().split(' ').join('')}` : `/es/results/${tag.toLowerCase().split(' ').join('')}` );
                            }
                          }} key={index}>{allTopics?.[tag.toLowerCase().split(' ').join('')]?.label}</TextLink>  
                        }
                      }
                      )}
                    </div>
                    </div>
                    // </TextLink>

                  ) : (
                    (card?.key=='tools' || card?.key=='prior') ? (
                     <Body>
                        {currentEvent?.localizeData?.map((desc, index) => {
                          if(lng=='en' && desc?.locale=="en-US" && desc?.previewData?.[0]){
                            return (card?.key=='tools' ? convertQuotedHtmlToPlain(desc?.previewData?.[0]?.sectionTwo) : (card?.key=='prior' ? convertQuotedHtmlToPlain(desc?.previewData?.[0]?.sectionThree) : ''))
                            
                          }else if(lng=='es' && desc?.locale=="es-ES" &&  desc?.previewData?.[0]){
                            return (card?.key=='tools' ? convertQuotedHtmlToPlain(desc?.previewData?.[0]?.sectionTwo) : (card?.key=='prior' ? convertQuotedHtmlToPlain(desc?.previewData?.[0]?.sectionThree) : ''))
                          }
                        }
                        
                        )}
                      </Body>
                    ) : ( (card?.key=='ideal' || card?.icon=="services" ) && 
                      <Body size="small"> { card?.icon=="services" ? convertQuotedHtmlToPlain(card?.description)  : ( currentEvent?.localizeData?.map((desc, index) => {
                        if(lng=='en' && desc?.locale=="en-US" &&  desc?.previewData?.[0]){
                          return (card?.key=='ideal' ? convertQuotedHtmlToPlain(desc?.previewData?.[0]?.sectionOne) : "");
                          
                        }else if(lng=='es' && desc?.locale=="es-ES" &&  desc?.previewData?.[0]){
                          return (card?.key=='ideal' ? convertQuotedHtmlToPlain(desc?.previewData?.[0]?.sectionOne) : "");
                        }
                      }
                      
                      ))  }</Body>
                    )
                  ) }
                </div>
              </div>
            </div>
          </TileContainer>
        </div>
      )}
    </div>
  )
}

export default EventPreview